export default "/images/b7160ff84662dfec71ef94e3bbe88060.png";